// @flow
import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import { Button, Dimmer, Dropdown, Header, Loader, Grid } from 'semantic-ui-react';
import { assign, first } from 'lodash';
import type { LocationShape, RouterHistory, Match } from 'react-router-dom';
import { parse, stringify } from 'query-string';
import { getReports } from '../../modules/client';
import FloatingActionsHover from '../molecules/FloatingActionsHover';
import ShareModal from '../molecules/ShareModal';
import DeleteModal from '../molecules/DeleteModal';
import Poseidon from './Poseidon';
import { REPORTING_API } from '../../modules/consts';

type Props = {
    reportsExist: boolean,
    history: RouterHistory,
    location: LocationShape & { search: string },
    match: Match & { params: { reportId: Guid } },
    onDeleteReport: (Guid, Guid) => Promise<void>,
    onShareReport: (Guid, any) => Promise<void>,
    user: User
};
export default class Home extends Component<
    Props,
    {
        reports: Report[],
        iframeLoaded: boolean,
        loading: boolean,
        selectedReportId: ?Guid,
        showShareModal: boolean,
        showDeleteModal: boolean
    }
> {
    constructor() {
        super();
        this.state = {
            reports: [],
            iframeLoaded: false,
            loading: true,
            selectedReportId: null,
            showShareModal: false,
            showDeleteModal: false
        };
    }
    onShare(exportType: string) {
        this.setState({ showShareModal: true });
    }
    render() {
        const { iframeLoaded, showShareModal, showDeleteModal } = this.state;
        const selectedReportId = this.props.match.params.reportId;
        const currentQuery = parse(this.props.location.search || '');
        const clientId = currentQuery.clientId;
        const reportParams = stringify(assign(currentQuery, { id: selectedReportId }));
        const isAdmin =
            this.props.user.isAdmin.length &&
            this.props.user.isAdmin.indexOf(currentQuery.clientId) !== -1;

        let actionOptions = [];

        if (isAdmin) {
            actionOptions.push({
                // description: 'Edit Filters',
                icon: 'edit',
                onClick: () =>
                    window.open(`${REPORTING_API}/report/home/editor?${reportParams}`, '_blank')
            });

            if (selectedReportId) {
                actionOptions.unshift({
                    // description: 'Share',
                    icon: 'share alternate',
                    onClick: () => this.setState({ showShareModal: true })
                });
                actionOptions.push({
                    // description: 'Delete Report',
                    color: 'red',
                    icon: 'delete',
                    onClick: () => this.setState({ showDeleteModal: true })
                });
            }
        }

        const deliveryTypes = ['SMS', 'Email', 'App Message', 'Push Notification'].map(el => ({
            text: el,
            value: el
        }));
        const exportTypes = [
            { text: 'PDF', icon: 'file pdf outline', value: 'pdf' },
            { text: 'Image', icon: 'image', value: 'image' }
        ];
        const source = `${REPORTING_API}/report/?${reportParams}`;
        const noSelectionText = (
            <Grid centered columns={1} style={{ height: '100%' }}>
                <Grid.Row verticalAlign="middle">
                    <Grid.Column textAlign="center">
                        {this.props.reportsExist
                            ? 'Select a report on the left to begin.'
                            : 'You do not have any reports.'}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );

        return (
            <div style={{ height: '100%' }}>
                {selectedReportId ? (
                    <div>
                        {iframeLoaded ? null : (
                            <Loader
                                active
                                style={{ alignItems: 'center', justifyContent: 'center' }}
                                inline="centered"
                                size="large"
                            >{`Loading Report...`}</Loader>
                        )}
                        <iframe
                            onLoad={() => this.setState({ iframeLoaded: true })}
                            style={{ width: '100%', border: 'none', height: '95vh' }}
                            src={source}
                        />
                    </div>
                ) : (
                    noSelectionText
                )}

                {actionOptions.length ? <FloatingActionsHover options={actionOptions} /> : null}

                <ShareModal
                    clientId={clientId}
                    attachmentId={selectedReportId}
                    attachmentType={'report'}
                    exportTypes={exportTypes}
                    onClose={() => this.setState({ showShareModal: false })}
                    onShare={this.props.onShareReport}
                    open={showShareModal}
                    onSavePermissions={(clientId, attachmentId, permissions) => Promise.resolve()} //TODO: wire this up
                    onShare={(attachmentId, data) => Promise.resolve()} //TODO: wire this up
                    users={[]} //TODO: send the actual users
                />

                <DeleteModal
                    open={showDeleteModal}
                    type="Report"
                    onCancel={() => this.setState({ showDeleteModal: false })}
                    onConfirm={() =>
                        this.props
                            .onDeleteReport(selectedReportId, clientId)
                            .then(() => this.setState({ showDeleteModal: false }))
                    }
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/pages/Reports.jsx